// Service.js
import axios from "axios";

const API_URL = process.env.REACT_APP_API_URL;

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 422) {
      console.warn("セッションが無効です。ログイン画面にリダイレクトします。");
      window.location.href = "/host/login";
      return;
    }
    return Promise.reject(error);
  }
);

const tokenHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("token")}`,
});

export const fetchPaymentLinks = async () => {
  const response = await axiosInstance.get("/api/payment-url", {
    headers: tokenHeader(),
  });
  return response.data;
};

export const fetchInvitees = async (params = {}) => {
  const response = await axiosInstance.get("/api/invitees", {
    headers: tokenHeader(),
    params,
  });
  return response.data;
};

export const addInvitee = async (newInvitee) => {
  const response = await axiosInstance.post("/api/invitees", newInvitee, {
    headers: tokenHeader(),
  });
  return response.data;
};

export const updateInvitee = async (invitee) => {
  const response = await axiosInstance.post("/api/invitees/update", invitee, {
    headers: tokenHeader(),
  });
  return response.data;
};

export const invitationSubmit = async (invitee) => {
  const response = await axiosInstance.post("/api/invitation/update", invitee, {
    headers: tokenHeader(),
  });
  return response.data;
};

export const fetchGuestById = async (id) => {
  const response = await fetch(`${API_URL}/api/invitation/check/${id}`, {
    method: "GET",
    headers: {
      "Content-Type": "application/json",
    },
  });
  return response;
};

export const checkGuestAttend = async (guestId) => {
  const response = await axiosInstance.post(
    "/api/invitees/checkIn/",
    { id: guestId },
    {
      headers: tokenHeader(),
    }
  );
  return response.data;
};

export const fetchAttendingInvitees = async () => {
  const response = await axiosInstance.get("/api/invitees/attending", {
    headers: tokenHeader(),
  });
  return response.data;
};

export const updateAttendanceManually = async (guestId, status) => {
  const response = await axiosInstance.post(
    "/api/invitees/manually",
    {
      id: guestId,
      is_attend: status,
    },
    {
      headers: tokenHeader(),
    }
  );
  return response.data;
};

export const addTable = async (newTable) => {
  const response = await axiosInstance.post("/api/arrangements", newTable, {
    headers: tokenHeader(),
  });
  return response.data;
};

export const fetchAllArrangementsWithGuests = async () => {
  const response = await axiosInstance.get("/api/arrangements/guests", {
    headers: tokenHeader(),
  });
  return response.data;
};

export const updateArrangement = async (id, updatedTable) => {
  const response = await axiosInstance.put(
    `/api/arrangements/${id}`,
    updatedTable,
    {
      headers: tokenHeader(),
    }
  );
  return response.data;
};

export const deleteInvitee = async (inviteeId) => {
  const response = await axiosInstance.delete(`/api/invitees/${inviteeId}`, {
    headers: tokenHeader(),
  });
  return response.data;
};

export const deleteTable = async (tableId) => {
  const response = await axiosInstance.delete(`/api/arrangements/${tableId}`, {
    headers: tokenHeader(),
  });
  return response.data;
};

export const fetchReceptionList = async () => {
  const response = await axiosInstance.get("/api/arrangements/reception", {
    headers: tokenHeader(),
  });
  return response.data;
};

export const fetchAnswerAvailability = async () => {
  const response = await axiosInstance.get("/api/answer-availability", {
    headers: tokenHeader(),
  });
  return response.data;
};

export const updateAnswerAvailability = async (newStatus) => {
  const response = await axiosInstance.put(
    "/api/answer-availability",
    {
      status: newStatus,
    },
    {
      headers: tokenHeader(),
    }
  );
  return response.data;
};

export const fetchSmoothReception = async () => {
  const response = await axiosInstance.get("/api/smooth-reception");
  return response.data;
};

export const updateSmoothReception = async (newStatus) => {
  const response = await axiosInstance.put(
    "/api/smooth-reception",
    {
      status: newStatus,
    },
    {
      headers: tokenHeader(),
    }
  );
  return response.data;
};

export const fetchHistory = async (
  page = 1,
  rowsPerPage = 10,
  filter = "all"
) => {
  const response = await axiosInstance.get("/api/history", {
    headers: tokenHeader(),
    params: { page, rowsPerPage, filter },
  });
  return response.data;
};
